import React from "react";
import orgImg from "../../images/organigramme.jpg";
const Team = () => {
  return (
    <div className={`container overflow-hidden p-10 `} data-nc-id="PageContact">
      <h2 className="text-xl font-bold text-center md:text-3xl text-primary">
        Notre Équipe
      </h2>
      <p className="mt-4 text-center text-secondary">Organigramme</p>

      <div className="mt-10">
        <img src={orgImg} alt="organigramme" />
      </div>
    </div>
  );
};

export default Team;
